/* eslint-disable no-undef */
import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'
import Cache from '@/helper/Cache.js'
import Account from '@/helper/AccountHelper.js'

/**
 * @method getProfile
 * @method getPoint
 * @method updateProfile
 * @method updateShippingAddress
 * @method changePassword
 * @method getAddresses
 * @method createAddress
 * @method updateAddress
 * @method postDeactivate
 * @method getProfileLevel
 * @method getProfileLevelSpending
 */
export default {
  config: function () {
    return Vue.bzbsConfig
  },
  token: function () {
    return Account.getCacheToken() ? Account.getCacheToken() : null
  },
  app_id: function () {
    if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')) != null) {
      if (
        Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId !=
        undefined
      ) {
        return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId
      } else {
        return Account.getCacheCustom('app_id')
      }
    } else {
      return Account.getCacheCustom('app_id')
    }
  },

  /**
   * Get user profile.
   * @param {object} strBzbsToken
   * @return {promises} Profile response.
   */
  getProfile: function (strBzbsToken) {
    var strUrl = this.config().bzbUrlService + '/profile/me'
    return BzbsApi.connectBzbsGet(strUrl, strBzbsToken)
  },

  /**
   * Get user profile.
   * @param {object} strBzbsToken
   * @return {promises} Profile response.
   */
  getAcceptanceConsent: function (strBzbsToken) {
    var strUrl = this.config().bzbUrlService + '/profile/me/acceptance'
    return BzbsApi.connectBzbsGet(strUrl, strBzbsToken)
  },

  /**
   * Get point.
   * @param {string} strBzbsToken
   * @return {promises} Point response.
   */
  getPoint: function (strBzbsToken) {
    var strUrl = this.config().bzbUrlService + '/profile/me/updated_points'
    return BzbsApi.connectBzbsGet(strUrl, strBzbsToken)
  },

  /**
   * Update user profile.
   * @param {string} strBzbsToken
   * @param {object} objProfileInfo
   * @param {object} objProfileAdress
   * @param {string} strExtendJson
   * @param {string} strUploadKey
   * @param {object} objUpload
   * @return {promises} user response.
   */
  updateProfile: function (
    strBzbsToken,
    objProfileInfo,
    objProfileAdress,
    strExtendJson,
    strUploadKey,
    objUpload,
  ) {
    var params = {}

    if (strExtendJson) {
      params.extendjsonstring = JSON.stringify(strExtendJson)
    }
    if (objProfileInfo) {
      if (objProfileInfo.strFirstName)
        params.firstname = objProfileInfo.strFirstName
      params.shippingfirstname = objProfileInfo.strFirstName

      if (objProfileInfo.strLastName)
        params.lastname = objProfileInfo.strLastName
      params.shippinglastname = objProfileInfo.strLastName

      if (objProfileInfo.strGender) params.gender = objProfileInfo.strGender

      if (objProfileInfo.strBirthDate)
        params.birthdate = objProfileInfo.strBirthDate

      if (objProfileInfo.Refercode) params.Refercode = objProfileInfo.Refercode

      if (objProfileInfo.strContactNumber)
        params.contact_Number = objProfileInfo.strContactNumber

      if (objProfileInfo.strEmail) params.email = objProfileInfo.strEmail

      if (objProfileInfo.strNationalIdCard)
        params.idcard = objProfileInfo.strNationalIdCard

      if (objProfileInfo.strLocale) params.locale = objProfileInfo.strLocale

      if (objProfileInfo.isNotificationEnable)
        params.notification = objProfileInfo.isNotificationEnable

      if (objProfileInfo.strIncome) params.income = objProfileInfo.strIncome

      if (objProfileInfo.strInterests)
        params.interests = objProfileInfo.strInterests

      if (objProfileInfo.strReligion) params.region = objProfileInfo.strReligion

      if (objProfileInfo.strMaritalStatus)
        params.maritalstatus = objProfileInfo.strMaritalStatus

      if (objProfileInfo.strNationality)
        params.nationality = objProfileInfo.strNationality

      if (objProfileInfo.strHighestEducation)
        params.highesteducation = objProfileInfo.strHighestEducation

      if (objProfileInfo.strOccupation)
        params.occupation = objProfileInfo.strOccupation

      if (objProfileInfo.strPassport)
        params.passport = objProfileInfo.strPassport

      if (objProfileInfo.strDriverLicenseNumber)
        params.driverlicense = objProfileInfo.strDriverLicenseNumber

      if (objProfileInfo.strDriverLicenseNumber)
        params.displayname = objProfileInfo.strDriverLicenseNumber

      if (objProfileInfo.otp) params.otp = objProfileInfo.otp

      if (objProfileInfo.refcode) params.refcode = objProfileInfo.refcode
    }

    if (objProfileAdress) {
      if (objProfileAdress.strAddress)
        params.address = objProfileAdress.strAddress

      if (objProfileAdress.strVillage)
        params.village = objProfileAdress.strVillage

      if (objProfileAdress.strBuilding)
        params.building = objProfileAdress.strBuilding

      if (objProfileAdress.strNumber) params.number = objProfileAdress.strNumber

      if (objProfileAdress.strMoo) params.moo = objProfileAdress.strMoo

      if (objProfileAdress.strRoom) params.room = objProfileAdress.strRoom

      if (objProfileAdress.strFloor) params.floor = objProfileAdress.strFloor

      if (objProfileAdress.strSoi) params.soi = objProfileAdress.strSoi

      if (objProfileAdress.strRoad) params.road = objProfileAdress.strRoad

      if (objProfileAdress.strCountryCode)
        params.country_code = objProfileAdress.strCountryCode

      if (objProfileAdress.strCountryName)
        params.country_name = objProfileAdress.strCountryName

      if (objProfileAdress.strProvinceCode)
        params.province_code = objProfileAdress.strProvinceCode

      if (objProfileAdress.strProvinceName)
        params.province_name = objProfileAdress.strProvinceName

      if (objProfileAdress.strDistrictCode)
        params.district_code = objProfileAdress.strDistrictCode

      if (objProfileAdress.strDistrictName)
        params.district_name = objProfileAdress.strDistrictName

      if (objProfileAdress.strSubDistrictCode)
        params.subdistrict_code = objProfileAdress.strSubDistrictCode

      if (objProfileAdress.strSubDistrictName)
        params.subdistrict_name = objProfileAdress.strSubDistrictName

      if (objProfileAdress.strZipcode)
        params.zipcode = objProfileAdress.strZipcode
    }
    var strUrl = this.config().bzbUrlService + '/profile/me'
    return BzbsApi.connectBzbsPost(
      strUrl,
      strBzbsToken,
      params,
      strUploadKey,
      objUpload,
    )
  },
  updateProfileNew: function (
    strBzbsToken,
    objProfileInfo,
    objProfileAdress,
    strExtendJson,
    strUploadKey,
    objUpload,
  ) {
    var params = {}

    if (strExtendJson) {
      params.extendjsonstring = JSON.stringify(strExtendJson)
    }
    if (objProfileInfo) {
      if (objProfileInfo.strFirstName)
        params.firstname = objProfileInfo.strFirstName

      if (objProfileInfo.strLastName)
        params.lastname = objProfileInfo.strLastName

      if (objProfileInfo.strGender) params.gender = objProfileInfo.strGender

      if (objProfileInfo.strBirthDate)
        params.birthdate = objProfileInfo.strBirthDate

      if (objProfileInfo.Refercode) params.Refercode = objProfileInfo.Refercode

      if (objProfileInfo.strContactNumber)
        params.contact_Number = objProfileInfo.strContactNumber

      if (objProfileInfo.strEmail) params.email = objProfileInfo.strEmail

      if (objProfileInfo.strNationalIdCard)
        params.idcard = objProfileInfo.strNationalIdCard

      if (objProfileInfo.strLocale) params.locale = objProfileInfo.strLocale

      if (objProfileInfo.isNotificationEnable)
        params.notification = objProfileInfo.isNotificationEnable

      if (objProfileInfo.strIncome) params.income = objProfileInfo.strIncome

      if (objProfileInfo.strInterests)
        params.interests = objProfileInfo.strInterests

      if (objProfileInfo.strReligion) params.region = objProfileInfo.strReligion

      if (objProfileInfo.strMaritalStatus)
        params.maritalstatus = objProfileInfo.strMaritalStatus

      if (objProfileInfo.strNationality)
        params.nationality = objProfileInfo.strNationality

      if (objProfileInfo.strHighestEducation)
        params.highesteducation = objProfileInfo.strHighestEducation

      if (objProfileInfo.strOccupation)
        params.occupation = objProfileInfo.strOccupation

      if (objProfileInfo.strPassport)
        params.passport = objProfileInfo.strPassport

      if (objProfileInfo.strDriverLicenseNumber)
        params.driverlicense = objProfileInfo.strDriverLicenseNumber

      if (objProfileInfo.strDriverLicenseNumber)
        params.displayname = objProfileInfo.strDriverLicenseNumber

      if (objProfileInfo.otp) params.otp = objProfileInfo.otp

      if (objProfileInfo.refcode) params.refcode = objProfileInfo.refcode
    }

    if (objProfileAdress) {
      if (objProfileAdress.strAddress)
        params.address = objProfileAdress.strAddress

      if (objProfileAdress.strVillage)
        params.village = objProfileAdress.strVillage

      if (objProfileAdress.strBuilding)
        params.building = objProfileAdress.strBuilding

      if (objProfileAdress.strNumber) params.number = objProfileAdress.strNumber

      if (objProfileAdress.strMoo) params.moo = objProfileAdress.strMoo

      if (objProfileAdress.strRoom) params.room = objProfileAdress.strRoom

      if (objProfileAdress.strFloor) params.floor = objProfileAdress.strFloor

      if (objProfileAdress.strSoi) params.soi = objProfileAdress.strSoi

      if (objProfileAdress.strRoad) params.road = objProfileAdress.strRoad

      if (objProfileAdress.strCountryCode)
        params.country_code = objProfileAdress.strCountryCode

      if (objProfileAdress.strCountryName)
        params.country_name = objProfileAdress.strCountryName

      if (objProfileAdress.strProvinceCode)
        params.province_code = objProfileAdress.strProvinceCode

      if (objProfileAdress.strProvinceName)
        params.province_name = objProfileAdress.strProvinceName

      if (objProfileAdress.strDistrictCode)
        params.district_code = objProfileAdress.strDistrictCode

      if (objProfileAdress.strDistrictName)
        params.district_name = objProfileAdress.strDistrictName

      if (objProfileAdress.strSubDistrictCode)
        params.subdistrict_code = objProfileAdress.strSubDistrictCode

      if (objProfileAdress.strSubDistrictName)
        params.subdistrict_name = objProfileAdress.strSubDistrictName

      if (objProfileAdress.strZipcode)
        params.zipcode = objProfileAdress.strZipcode
    }
    console.log('/api/profile/me', params)
    var strUrl = this.config().bzbUrlService + '/profile/me'
    return BzbsApi.connectBzbsPost(
      strUrl,
      strBzbsToken,
      params,
      strUploadKey,
      objUpload,
    )
  },

  RegisterLine(objProfileInfo, refcode = null, otp = null, strExtendJson) {
    console.log('objProfileInfo ::', objProfileInfo)
    var params = {}
    if (objProfileInfo) {
      if (objProfileInfo.strIdToken) params.id_token = objProfileInfo.strIdToken

      if (objProfileInfo.strContactNumber)
        params.contact_Number = objProfileInfo.strContactNumber

      if (objProfileInfo.strEmail) params.email = objProfileInfo.strEmail

      if (objProfileInfo.strFirstName)
        params.firstname = objProfileInfo.strFirstName

      if (objProfileInfo.strLastName)
        params.lastname = objProfileInfo.strLastName

      if (
        typeof objProfileInfo.strGender == Array &&
        objProfileInfo.strGender.length > 0
      ) {
        params.gender = objProfileInfo.strGender
      } else if (
        typeof objProfileInfo.strGender !== Array &&
        objProfileInfo.strGender
      ) {
        params.gender = objProfileInfo.strGender
      }

      if (objProfileInfo.strBirthDate)
        params.birthdate = objProfileInfo.strBirthDate
    }

    if (strExtendJson) {
      params.extendjsonstring = JSON.stringify(strExtendJson)
    }

    if (refcode) {
      params.refcode = refcode
    }
    if (otp) {
      params.otp = otp
    }

    if (params.id_token && typeof params.id_token == 'object') {
      params.id_token = params.id_token[0]
    }

    console.log('RegisterLine params ::', params)
    var strUrl = this.config().bzbUrlService + '/line/register'
    return BzbsApi.connectBzbsPost(strUrl, null, params, null, null)
  },

  RegisterSingleSignOn(objProfileInfo, refcode = null, otp = null) {
    console.log('objProfileInfo ::', objProfileInfo)
    var params = {}
    if (refcode) {
      params.refcode = refcode
    }
    if (otp) {
      params.otp = otp
    }
    if (objProfileInfo) {
      if (objProfileInfo.id_token) params.id_token = objProfileInfo.id_token

      if (objProfileInfo.app_id) params.app_id = objProfileInfo.app_id

      if (objProfileInfo.tokenType) params.tokenType = objProfileInfo.tokenType

      if (objProfileInfo.os) params.os = objProfileInfo.os

      if (objProfileInfo.firstname) params.firstname = objProfileInfo.firstname

      if (objProfileInfo.lastname) params.lastname = objProfileInfo.lastname

      if (objProfileInfo.birthdate) params.birthdate = objProfileInfo.birthdate

      if (
        typeof objProfileInfo.gender == Array &&
        objProfileInfo.gender.length > 0
      ) {
        params.gender = objProfileInfo.gender
      } else if (
        typeof objProfileInfo.gender !== Array &&
        objProfileInfo.gender
      ) {
        params.gender = objProfileInfo.gender
      }

      if (objProfileInfo.contact_number)
        params.contact_number = objProfileInfo.contact_number

      if (objProfileInfo.email) params.email = objProfileInfo.email

      if (objProfileInfo.idcard) params.idcard = objProfileInfo.idcard

      if (objProfileInfo.dataprivacy)
        params.dataprivacy = objProfileInfo.dataprivacy
      else params.dataprivacy = null

      if (objProfileInfo.termandcondition)
        params.termandcondition = objProfileInfo.termandcondition
      else params.termandcondition = null

      if (objProfileInfo.marketingOption)
        params.marketingOption = objProfileInfo.marketingOption
      else params.marketingOption = null

      if (objProfileInfo.consentemail)
        params.mktoption_email = objProfileInfo.consentemail
      else params.mktoption_email = 0

      if (objProfileInfo.consentsms)
        params.mktoption_sms = objProfileInfo.consentsms
      else params.mktoption_sms = 0

      if (objProfileInfo.consentline)
        params.mktoption_line = objProfileInfo.consentline
      else params.mktoption_line = 0

      if (objProfileInfo.consentAge)
        params.consentAge = objProfileInfo.consentAge
      else params.consentAge = null

      if (objProfileInfo.extendjsonstring)
        params.extendjsonstring = JSON.stringify(
          objProfileInfo.extendjsonstring,
        )
      if (objProfileInfo.custom_info) {
        params.custom_info = JSON.stringify(objProfileInfo.custom_info)
      }
      if (objProfileInfo.refusercode) {
        params.refusercode = objProfileInfo.refusercode
      }
    }
    if (objProfileInfo.uuid) {
      params.uuid = objProfileInfo.uuid
    }

    if (params.id_token && typeof params.id_token == 'object') {
      params.id_token = params.id_token[0]
    }
    console.log('RegisterSingleSignOn params ::', params)
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/register'
    return BzbsApi.connectBzbsPost(strUrl, null, params, null, null)
  },

  RegisterProfile(
    strBzbsToken,
    objProfileInfo,
    objProfileAdress,
    strExtendJson,
    strUploadKey,
    objUpload,
  ) {
    var params = {}

    if (strExtendJson) {
      params.extendjsonstring = JSON.stringify(strExtendJson)
    }
    if (objProfileInfo) {
      if (objProfileInfo.strFirstName)
        params.firstname = objProfileInfo.strFirstName

      if (objProfileInfo.struserId) params.userId = objProfileInfo.struserId

      if (objProfileInfo.strjoinDate)
        params.joinDate = objProfileInfo.strjoinDate

      if (objProfileInfo.strLastName)
        params.lastname = objProfileInfo.strLastName

      if (objProfileInfo.strGender) params.gender = objProfileInfo.strGender

      if (objProfileInfo.strBirthDate)
        params.birthdate = objProfileInfo.strBirthDate

      if (objProfileInfo.Refercode) params.Refercode = objProfileInfo.Refercode

      if (objProfileInfo.strContactNumber)
        params.contact_Number = objProfileInfo.strContactNumber

      if (objProfileInfo.strEmail) params.email = objProfileInfo.strEmail

      if (objProfileInfo.strNationalIdCard)
        params.idcard = objProfileInfo.strNationalIdCard

      if (objProfileInfo.strLocale) params.locale = objProfileInfo.strLocale

      if (objProfileInfo.isNotificationEnable)
        params.notification = objProfileInfo.isNotificationEnable

      if (objProfileInfo.strIncome) params.income = objProfileInfo.strIncome

      if (objProfileInfo.strInterests)
        params.interests = objProfileInfo.strInterests

      if (objProfileInfo.strReligion) params.region = objProfileInfo.strReligion

      if (objProfileInfo.strMaritalStatus)
        params.maritalstatus = objProfileInfo.strMaritalStatus

      if (objProfileInfo.strNationality)
        params.nationality = objProfileInfo.strNationality

      if (objProfileInfo.strHighestEducation)
        params.highesteducation = objProfileInfo.strHighestEducation

      if (objProfileInfo.strOccupation)
        params.occupation = objProfileInfo.strOccupation

      if (objProfileInfo.strPassport)
        params.passport = objProfileInfo.strPassport

      if (objProfileInfo.strDriverLicenseNumber)
        params.driverlicense = objProfileInfo.strDriverLicenseNumber

      if (objProfileInfo.strDriverLicenseNumber)
        params.displayname = objProfileInfo.strDriverLicenseNumber

      if (objProfileInfo.otp) params.otp = objProfileInfo.otp

      if (objProfileInfo.refcode) params.refcode = objProfileInfo.refcode

      if (objProfileInfo.refusercode)
        params.refusercode = objProfileInfo.refusercode
    }

    if (objProfileAdress) {
      if (objProfileAdress.strAddress)
        params.address = objProfileAdress.strAddress

      if (objProfileAdress.strVillage)
        params.village = objProfileAdress.strVillage

      if (objProfileAdress.strBuilding)
        params.building = objProfileAdress.strBuilding

      if (objProfileAdress.strNumber) params.number = objProfileAdress.strNumber

      if (objProfileAdress.strMoo) params.moo = objProfileAdress.strMoo

      if (objProfileAdress.strRoom) params.room = objProfileAdress.strRoom

      if (objProfileAdress.strFloor) params.floor = objProfileAdress.strFloor

      if (objProfileAdress.strSoi) params.soi = objProfileAdress.strSoi

      if (objProfileAdress.strRoad) params.road = objProfileAdress.strRoad

      if (objProfileAdress.strCountryCode)
        params.country_code = objProfileAdress.strCountryCode

      if (objProfileAdress.strCountryName)
        params.country_name = objProfileAdress.strCountryName

      if (objProfileAdress.strProvinceCode)
        params.province_code = objProfileAdress.strProvinceCode

      if (objProfileAdress.strProvinceName)
        params.province_name = objProfileAdress.strProvinceName

      if (objProfileAdress.strDistrictCode)
        params.district_code = objProfileAdress.strDistrictCode

      if (objProfileAdress.strDistrictName)
        params.district_name = objProfileAdress.strDistrictName

      if (objProfileAdress.strSubDistrictCode)
        params.subdistrict_code = objProfileAdress.strSubDistrictCode

      if (objProfileAdress.strSubDistrictName)
        params.subdistrict_name = objProfileAdress.strSubDistrictName

      if (objProfileAdress.strZipcode)
        params.zipcode = objProfileAdress.strZipcode
    }
    console.log('/crmpluscustomer/profile', params)
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/profile'
    return BzbsApi.connectBzbsPost(
      strUrl,
      strBzbsToken,
      params,
      strUploadKey,
      objUpload,
    )
  },
  /**
   * Update user shipping address.
   * @param {string} strBzbsToken
   * @param {object} objProfileShippingAddress
   * @return {promises} Profile shipping address.
   */
  updateShippingAddress: function (strBzbsToken, objProfileShippingAddress) {
    var params = {}

    if (objProfileShippingAddress) {
      if (objProfileShippingAddress.strFirstName)
        params.shippingfirstname = objProfileShippingAddress.strFirstName

      if (objProfileShippingAddress.strLastName)
        params.shippinglastname = objProfileShippingAddress.strLastName

      if (objProfileShippingAddress.strContactNumber)
        params.shipping_contact_number =
          objProfileShippingAddress.strContactNumber

      if (objProfileShippingAddress.strEmail)
        params.shipping_email = objProfileShippingAddress.strEmail

      if (objProfileShippingAddress.strAddress)
        params.shipping_address = objProfileShippingAddress.strAddress

      if (objProfileShippingAddress.strZipcode)
        params.shipping_zipcode = objProfileShippingAddress.strZipcode

      if (objProfileShippingAddress.strProvinceCode)
        params.shipping_province_code =
          objProfileShippingAddress.strProvinceCode

      if (objProfileShippingAddress.strProvinceName)
        params.shipping_province_name =
          objProfileShippingAddress.strProvinceName

      if (objProfileShippingAddress.strDistrictCode)
        params.shipping_district_code =
          objProfileShippingAddress.strDistrictCode

      if (objProfileShippingAddress.strDistrictName)
        params.shipping_district_name =
          objProfileShippingAddress.strDistrictName

      if (objProfileShippingAddress.strSubDistrictCode)
        params.shipping_subdistrict_code =
          objProfileShippingAddress.strSubDistrictCode

      if (objProfileShippingAddress.strSubDistrictName)
        params.shipping_subdistrict_name =
          objProfileShippingAddress.strSubDistrictName

      if (objProfileShippingAddress.strNationalIdCard)
        params.idcard = objProfileShippingAddress.strNationalIdCard
    }

    var strUrl = this.config().bzbUrlService + '/profile/me/shipping'
    return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params)
  },

  /**
   * Change bzbs password
   * @param {string} strBzbsToken
   * @param {string} strCurrent Current password
   * @param {string} strChange New password
   */
  changePassword: function (strBzbsToken, strCurrent, strChange) {
    var params = {
      current: strCurrent,
      change: strChange,
    }

    var strUrl = this.config().bzbUrlService + '/profile/me/change_password'
    return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params, null, null)
  },

  /**
   * Get Addresses.
   * @param {string} strBzbsToken
   * @return {promises} Addresses response.
   */
  getAddresses: function (strBzbsToken) {
    var strUrl = this.config().bzbUrlService + '/profile/me/addresses'
    return BzbsApi.connectBzbsGet(strUrl, strBzbsToken)
  },

  /**
   * Create Address.
   * @param {string} strBzbsToken
   * @return {promises} Address response.
   */
  createAddress: function (strBzbsToken, params) {
    var strUrl = this.config().bzbUrlService + '/profile/me/address'
    return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params, null, null)
  },

  /**
   * Update Address.
   * @param {string} strBzbsToken
   * @return {promises} Address response.
   */
  updateAddress: function (strBzbsToken, params, id) {
    params.key = id
    var strUrl = this.config().bzbUrlService + '/profile/me/address'
    return BzbsApi.connectBzbsPost(strUrl, strBzbsToken, params, null, null)
  },
  deviceresume: function () {
    var params = {}
    var strUrl = this.config().bzbUrlService + '/auth/device_resume'
    return BzbsApi.connectBzbsPost(strUrl, this.token(), params, null, null)
  },

  apicrmpluslevel: function (params) {
    var strUrl = this.config().bzbModuleUrl + '/crmpluslevel/list'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), params)
  },

  getProfileLevel: function (params) {
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/profile_level'
    return BzbsApi.connectBzbsGet(strUrl, null, params)
  },
  getProfileLevelSpending: function (params) {
    var strUrl =
      this.config().bzbModuleUrl + '/crmpluscustomer/profile_level_spending'
    return BzbsApi.connectBzbsGet(strUrl, null, params)
  },

  postDeactivate: function (params) {
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/deactivate'
    return BzbsApi.connectBzbsPost(strUrl, this.token(), params, null, null)
  },

  //   apiRequestOTP: function (strBzbsToken) {
  //     var strUrl = this.config().bzbUrlService + '/auth/otp'
  //     return BzbsApi.connectBzbsGet(strUrl, strBzbsToken)
  //   },
  bzbsAnalyticInitialReward: function (campaignid, lineID, userId, adsId) {
    //the event occurred
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    /* When user login #https://developer.matomo.org/guides/tracking-javascript-guide
     *
     * _paq.push(['setUserId', 'USER_ID_HERE']);
     *
     * */

    _paq.push(['setUserId', userId])
    _paq.push(['setCustomDimension', 2, this.app_id()])
    _paq.push(['setCustomDimension', 3, campaignid])
    _paq.push(['setCustomDimension', 4, lineID])
    _paq.push(['setCustomDimension', 5, adsId])
    _paq.push(['trackPageView'])
    _paq.push(['enableLinkTracking'])
    ;(function () {
      //U is Bzbs Analytic Url;
      var u = Vue.bzbsConfig.bzbsAnalyticUrl
      _paq.push(['setTrackerUrl', u + '/matomo.php'])
      _paq.push(['setSiteId', Vue.bzbsConfig.bzbsAnalyticId])
      console.log('Vue.bzbsConfig', Vue.bzbsConfig)
      var d = document,
        g = d.createElement('script'),
        s = d.getElementsByTagName('script')[0]
      g.type = 'text/javascript'
      g.async = true
      g.defer = true
      g.src = u + '/matomo.js'
      s.parentNode.insertBefore(g, s)
    })()
  },
}
